import React from "react";
import "./Body.css";
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    leftDiv: {
        display: "flex",
        flexDirection: "column",
        width: "15%",
    },
    middleDiv: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    rightDiv: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        width: "15%",
    },
    columnTextDiv: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-around",
        height: "100%"
    },
    rowDivs: {
        display: "flex",
        flexDirection: "row",
        width: "fit-content",
    },
    generalText: {
        fontFamily: "EncodeSansExtraBold",
        textAlign: "center",
        [theme.breakpoints.up('xl')]: {
            fontSize: "64px",
        },
        [theme.breakpoints.down('xl')]: {
            fontSize: "56px",
        },
        [theme.breakpoints.down('lg')]: {
            fontSize: "48px",
        },
        [theme.breakpoints.down('md')]: {
            fontSize: "40px",
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: "34px",
        },
    },
    pinkRectangle: {
        color: "white",
        backgroundColor: "#bb0d66",
        position: "relative",
        clipPath: "polygon(0 0, 100% 10%, 100% 90%, 0 100%)",
    },
    blueRectangle: {
        color: "white",
        backgroundColor: "#004285",
        position: "relative",
        height: "130%",
        clipPath: "polygon(0 0, 100% 10%, 100% 90%, 0 100%)",
    },
    lightBlueRectangle: {
        color: "#FFF",
        backgroundColor: "#9fcde7",
        position: "relative",
        clipPath: "polygon(0 5%, 100% 0, 100% 100%, 0 95%)",
    },
    spacing: {
        marginLeft: "10px",
        paddingTop: "10px",
    },
    carImage: {
        [theme.breakpoints.up('xl')]: {
            width: "216px",
            height: "auto",
            marginTop: "54px",
        },
        [theme.breakpoints.down('xl')]: {
            width: "200px",
            height: "auto",
            marginTop: "54px",
        },
        [theme.breakpoints.down('lg')]: {
            width: "176px",
            height: "auto",
            marginTop: "54px",
        },
        [theme.breakpoints.down('md')]: {
            width: "144px",
            height: "auto",
            marginTop: "54px",
        },
        [theme.breakpoints.down('sm')]: {
            width: "120px",
            height: "auto",
            marginTop: "54px",
        },
    }
}));
const Body = () => {
    const classes = useStyles();

    return (
        <React.Fragment>
            <div className={classes.middleDiv}>
                <div className={classes.columnTextDiv}>
                    <div className={classes.rowDivs}>
                        <h2
                            className="font-face-poppins-bold exclamation-mark1"
                            style={{
                                fontSize: "120px",
                                height: "80px",
                            }}
                        >
                            !
                        </h2>
                        <h2 className={`${classes.generalText} ${classes.pinkRectangle} ${classes.spacing}`}
                        >
                            Bienvenidos
                        </h2>
                        <h2
                            className={`${classes.generalText} ${classes.spacing}`}
                            style={{color: "#bb0d66"}}
                        >
                            a un programa
                        </h2>
                    </div>
                    <div className={classes.rowDivs}>
                        <h2
                            className={`${classes.generalText} ${classes.spacing}`}
                            style={{color: "#bb0d66"}}
                        >
                            de
                        </h2>
                        <h2 className={`${classes.generalText} ${classes.blueRectangle} ${classes.spacing}`}>
                            grandes descuentos
                        </h2>
                    </div>
                    <div className={classes.rowDivs}>
                        <h2
                            className={`${classes.generalText} ${classes.spacing}`}
                            style={{color: "#bb0d66"}}
                        >
                            y
                        </h2>
                        <h2 className={`${classes.generalText} ${classes.lightBlueRectangle} ${classes.spacing}`}>
                            beneficios
                        </h2>
                        <h2
                            className={`${classes.spacing} font-face-poppins-bold exclamation-mark2`}
                            style={{
                                fontSize: "120px",
                                height: "80px",
                            }}
                        >
                            !
                        </h2>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Body;
